import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDkd2TOKmIslIYrmGrobssOV-mt8HdDU1M",
    authDomain: "prism.toolix.in",
    projectId: "prism-ats-validator-001",
    storageBucket: "prism-ats-validator-001.firebasestorage.app",
    messagingSenderId: "852114718243",
    appId: "1:852114718243:web:9bb2afe1b35a24499e3b96",
    measurementId: "G-EY0DYDXCJ8"
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
